import { Pencil } from "lucide-react";
import { Button } from "@/components/ui/button";
import { formatNumber } from "@/lib/format";
import { cn } from "@/lib/utils";

export function KipkruidenCell({ p }) {
  if (p.stock_managed === false) return <span className="text-muted-foreground">—</span>;
  return (
    <span className={cn("font-mono font-semibold", p.vdb_exceeds_total && "text-status-critical")}
      title={p.vdb_exceeds_total ? "Van den Brink is hoger dan de webshopvoorraad — controleer de invoer" : undefined}
      data-testid={`kk-stock-${p.id}`}>
      {formatNumber(p.stock_kipkruiden, 1)}
    </span>
  );
}

export function VdbCell({ p, canEdit, onEdit }) {
  if (p.stock_managed === false) return <span className="text-muted-foreground">—</span>;
  return (
    <div className="flex items-center justify-end gap-2">
      <span className="font-mono font-semibold" data-testid={`vdb-stock-${p.id}`}>{formatNumber(p.stock_vandenbrink, 1)}</span>
      {p.vdb_source === "xcore" && (
        <span className="text-[11px] uppercase tracking-wider text-muted-foreground" data-testid={`vdb-source-${p.id}`}>xCore</span>
      )}
      {canEdit && p.vdb_source !== "xcore" && (
        <Button size="sm" variant="outline" className="h-10 px-3" data-testid={`vdb-edit-${p.id}`}
          onClick={(e) => { e.stopPropagation(); onEdit(p); }}>
          <Pencil className="w-4 h-4 mr-1" /> Aanpassen
        </Button>
      )}
    </div>
  );
}
